export default {
  methods: {
    scrollToTop: function() {
      window.scrollTo(0, 0);
    }
  }
};
